/**
 * Default Branding Colors
 *
 * These are the default brand colors applied to every new gym organization.
 * They are used as fallbacks throughout the app when an org hasn't customized
 * its branding yet. Keep this as the single source of truth — import from here
 * instead of hardcoding hex values.
 */

export const DEFAULT_PRIMARY_COLOR = '#455fff';
export const DEFAULT_SECONDARY_COLOR = '#57658e';
